module.exports = __webpack_public_path__ + "media/img/Landing_Page/logos/7-bbb15086c680d7efeba53f41ac4ab736.jpg";